import { defineWorkflow } from './workflow-builder'

/**
 * WF-OPN-01 (Stock Opname Session) — nomor workflow 16, entitas `opname_session`. Sumber: TL 12B WF-OPN-01 + BA 12F
 * OPN-01/01B/03 + prototype v7.44. Selisih (laporan 20):
 * - Ditambah aksi `ACT_OPN_RECOUNT` (Validasi Selisih → Proses Penghitungan) untuk "Tolak — Hitung Ulang" per rak:
 *   TL punya komponen `CMP_OPN_RECOUNT_RACK` tetapi tidak punya aksinya.
 * - Aksi `ACT_OPN_FINISH_COUNT` dijalankan Operator yang mengunci tugas TERAKHIR sesi itu (BA: sesi masuk antrean
 *   pengesahan setelah seluruh tugas operator selesai).
 * - Condition CASL TL `{warehouse_type: …}` tidak dipakai — kolom itu tidak ada di ERD; pembatasan gudang dijaga handler.
 */
export const WF_OPN = defineWorkflow({
  no: 16,
  code: 'WF-OPN-01',
  name: 'Stock Opname Session Workflow',
  entity: 'opname_session',
  statuses: [
    ['OPN_SCHEDULED', 'Terjadwal', true, false, '#64748B', 'Sesi opname didaftarkan / terjadwal'],
    ['OPN_OPEN', 'Open', false, false, '#3B82F6', 'Sesi dibuka, penugasan per area dibagikan'],
    ['OPN_COUNTING', 'Proses Penghitungan', false, false, '#06B6D4', 'Operator melakukan blind count scan per rak'],
    [
      'OPN_VALIDATION',
      'Validasi Selisih',
      false,
      false,
      '#F59E0B',
      'Menunggu pengesahan hasil rak & penyelesaian selisih'
    ],
    ['OPN_COMPLETED', 'Completed', false, true, '#10B981', 'Sesi ditutup, adjustment stok tercatat'],
    ['OPN_CANCELLED', 'Cancelled', false, true, '#94A3B8', 'Sesi opname dibatalkan']
  ],
  actors: [
    ['ACT_OPN_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_OPN_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_OPN_OP_RM', 'Operator WH RM', 'operator_wh_rm', null],
    ['ACT_OPN_OP_FG', 'Operator WH FG', 'operator_wh_fg', null],
    ['ACT_OPN_SPV_RM', 'WH RM Supervisor', 'wh_rm_supervisor', null],
    ['ACT_OPN_SPV_FG', 'Supervisor WH FG', 'supervisor_wh_fg', null]
  ],
  components: [
    ['CMP_OPN_START', 'Tombol Mulai Opname', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_OPN_ASSIGN_AREA', 'Tombol Bagikan Tugas Area', 'ACTION', {}],
    ['CMP_OPN_SUBMIT_COUNT', 'Tombol Submit Hasil Hitung', 'ACTION', {}],
    ['CMP_OPN_VALIDATE_RACK', 'Tombol Sahkan Hasil Rak', 'ACTION', {}],
    ['CMP_OPN_RECOUNT_RACK', 'Tombol Tolak & Hitung Ulang', 'ACTION', { variant: 'outlined' }],
    ['CMP_OPN_CLOSE_SESSION', 'Tombol Tutup Sesi Opname', 'ACTION', {}],
    ['CMP_OPN_PANEL_HEADER', 'Panel Header Sesi Opname', 'PANEL', {}],
    ['CMP_OPN_PANEL_AREAS', 'Panel Area & Penugasan Rak', 'PANEL', {}],
    ['CMP_OPN_PANEL_VARIANCE', 'Panel Rekapitulasi Variance / Selisih', 'PANEL', {}]
  ],
  actions: [
    ['ACT_OPN_START_SESSION', 'OPN_SCHEDULED', 'OPN_OPEN', 'CMP_OPN_START', false, false, null],
    ['ACT_OPN_DISPATCH_TASKS', 'OPN_OPEN', 'OPN_COUNTING', 'CMP_OPN_ASSIGN_AREA', false, false, null],
    ['ACT_OPN_FINISH_COUNT', 'OPN_COUNTING', 'OPN_VALIDATION', 'CMP_OPN_SUBMIT_COUNT', false, false, null],
    ['ACT_OPN_RECOUNT', 'OPN_VALIDATION', 'OPN_COUNTING', 'CMP_OPN_RECOUNT_RACK', true, true, null],
    [
      'ACT_OPN_CLOSE',
      'OPN_VALIDATION',
      'OPN_COMPLETED',
      'CMP_OPN_CLOSE_SESSION',
      false,
      false,
      { is_closed: true, closed_at: '$NOW' }
    ],
    ['ACT_OPN_CANCEL', 'OPN_SCHEDULED', 'OPN_CANCELLED', 'CMP_OPN_START', true, true, null]
  ],
  eligibility: [
    ['ACT_OPN_START_SESSION', 'ACT_OPN_ADMIN_RM'],
    ['ACT_OPN_START_SESSION', 'ACT_OPN_ADMIN_FG'],
    ['ACT_OPN_DISPATCH_TASKS', 'ACT_OPN_ADMIN_RM'],
    ['ACT_OPN_DISPATCH_TASKS', 'ACT_OPN_ADMIN_FG'],
    ['ACT_OPN_FINISH_COUNT', 'ACT_OPN_OP_RM'],
    ['ACT_OPN_FINISH_COUNT', 'ACT_OPN_OP_FG'],
    ['ACT_OPN_RECOUNT', 'ACT_OPN_SPV_RM'],
    ['ACT_OPN_RECOUNT', 'ACT_OPN_SPV_FG'],
    ['ACT_OPN_CLOSE', 'ACT_OPN_ADMIN_RM'],
    ['ACT_OPN_CLOSE', 'ACT_OPN_ADMIN_FG'],
    ['ACT_OPN_CANCEL', 'ACT_OPN_ADMIN_RM'],
    ['ACT_OPN_CANCEL', 'ACT_OPN_ADMIN_FG']
  ],
  panels: [
    ['CMP_OPN_PANEL_HEADER', 'OPN_SCHEDULED', 'write', 'ACT_OPN_ADMIN_RM'],
    ['CMP_OPN_PANEL_HEADER', 'OPN_OPEN', 'read', null],
    ['CMP_OPN_PANEL_HEADER', 'OPN_COMPLETED', 'read', null],
    ['CMP_OPN_PANEL_AREAS', 'OPN_OPEN', 'write', 'ACT_OPN_ADMIN_RM'],
    ['CMP_OPN_PANEL_AREAS', 'OPN_COUNTING', 'read', null],
    ['CMP_OPN_PANEL_VARIANCE', 'OPN_VALIDATION', 'write', 'ACT_OPN_SPV_RM'],
    ['CMP_OPN_PANEL_VARIANCE', 'OPN_COMPLETED', 'read', null]
  ],
  emailStatuses: ['OPN_OPEN', 'OPN_VALIDATION', 'OPN_COMPLETED']
})

/**
 * WF-DSR-01 (Opname Discrepancy) — nomor workflow 17, entitas `discrepancy`. Sumber: TL 12B WF-DSR-01 + BA 12F
 * OPN-04/04A. Window investigasi RM H+5 / approval H+7, FG H+0 / H+1 (SLA_DSR_*); eskalasi otomatis dijalankan sweep
 * handler (pengganti worker SLA). "Assign Re-Check Fisik" bukan perpindahan status (hanya menunjuk petugas).
 */
export const WF_DSR = defineWorkflow({
  no: 17,
  code: 'WF-DSR-01',
  name: 'Opname Discrepancy Workflow',
  entity: 'discrepancy',
  statuses: [
    ['DSR_INVESTIGATION', 'Investigation', true, false, '#F59E0B', 'Selisih dalam masa investigasi / pencarian'],
    ['DSR_PENDING_APP', 'Pending Approval', false, false, '#EF4444', 'Investigasi berakhir, diajukan untuk write-off'],
    ['DSR_RESOLVED_FOUND', 'Resolved - Found', false, true, '#10B981', 'Barang berhasil ditemukan melalui scan OPN-03'],
    ['DSR_ADJUSTED_WRITE_OFF', 'Adjusted - Not Found', false, true, '#64748B', 'Kadiv menyetujui write-off stok hilang']
  ],
  actors: [
    ['ACT_DSR_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_DSR_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_DSR_OP_RM', 'Operator WH RM', 'operator_wh_rm', null],
    ['ACT_DSR_OP_FG', 'Operator WH FG', 'operator_wh_fg', null],
    ['ACT_DSR_KADIV_RM', 'Kadiv WH RM', 'kadiv_wh_rm', null],
    ['ACT_DSR_KADIV_FG', 'Kadiv WH FG', 'kadiv_wh_fg', null]
  ],
  components: [
    ['CMP_DSR_ESCALATE', 'Tombol Eskalasi Sekarang', 'ACTION', {}],
    ['CMP_DSR_FOUND_SCAN', 'Tombol Ditemukan (Scan)', 'ACTION', {}],
    ['CMP_DSR_APPROVE_WO', 'Tombol Setujui Write-off', 'ACTION', { color: '#EF4444' }],
    ['CMP_DSR_REJECT_WO', 'Tombol Tolak & Perpanjang Window', 'ACTION', { variant: 'outlined' }],
    ['CMP_DSR_PANEL_TRACE', 'Panel Jejak Barang', 'PANEL', {}]
  ],
  actions: [
    ['ACT_DSR_ESCALATE_WO', 'DSR_INVESTIGATION', 'DSR_PENDING_APP', 'CMP_DSR_ESCALATE', false, false, null],
    ['ACT_DSR_SCAN_FOUND', 'DSR_INVESTIGATION', 'DSR_RESOLVED_FOUND', 'CMP_DSR_FOUND_SCAN', false, false, null],
    ['ACT_DSR_APP_WRITEOFF', 'DSR_PENDING_APP', 'DSR_ADJUSTED_WRITE_OFF', 'CMP_DSR_APPROVE_WO', false, false, null],
    ['ACT_DSR_REJ_WRITEOFF', 'DSR_PENDING_APP', 'DSR_INVESTIGATION', 'CMP_DSR_REJECT_WO', true, true, null],
    ['ACT_DSR_AUTO_ESCALATE', 'DSR_INVESTIGATION', 'DSR_PENDING_APP', 'CMP_DSR_ESCALATE', false, false, null]
  ],
  eligibility: [
    ['ACT_DSR_ESCALATE_WO', 'ACT_DSR_ADMIN_RM'],
    ['ACT_DSR_ESCALATE_WO', 'ACT_DSR_ADMIN_FG'],
    ['ACT_DSR_SCAN_FOUND', 'ACT_DSR_OP_RM'],
    ['ACT_DSR_SCAN_FOUND', 'ACT_DSR_OP_FG'],
    ['ACT_DSR_APP_WRITEOFF', 'ACT_DSR_KADIV_RM'],
    ['ACT_DSR_APP_WRITEOFF', 'ACT_DSR_KADIV_FG'],
    ['ACT_DSR_REJ_WRITEOFF', 'ACT_DSR_KADIV_RM'],
    ['ACT_DSR_REJ_WRITEOFF', 'ACT_DSR_KADIV_FG']
  ],
  panels: [
    ['CMP_DSR_PANEL_TRACE', 'DSR_INVESTIGATION', 'read', null],
    ['CMP_DSR_PANEL_TRACE', 'DSR_PENDING_APP', 'read', null]
  ],
  emailStatuses: ['DSR_PENDING_APP', 'DSR_RESOLVED_FOUND', 'DSR_ADJUSTED_WRITE_OFF']
})

export type OpnStatusCode = (typeof WF_OPN.spec.statuses)[number][0]
export type DsrStatusCode = (typeof WF_DSR.spec.statuses)[number][0]
export const buildWorkflowOpnSeed = () => {
  const a = WF_OPN.build()
  const b = WF_DSR.build()
  return Object.fromEntries(
    [...new Set([...Object.keys(a), ...Object.keys(b)])].map(key => [key, [...(a[key] ?? []), ...(b[key] ?? [])]])
  )
}
